var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "card", staticClass: "py-3 px-2 h-12 border" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }